import { PasswordInput } from "@mantine/core";
import React from "react";
import { withTranslation } from "react-i18next";

const PasswordField = ({
  label,
  value,
  disabled,
  placeholder,
  onChange,
  autoComplete = "off",
  form,
  validateName,
  required,
  onBlur,
  onInput,
}) => {
  return (
    <PasswordInput
      label={label}
      onChange={onChange}
      onInput={onInput}
      defaultValue={value}
      onBlur={onBlur}
      disabled={disabled}
      autoComplete={autoComplete}
      required={required}
      placeholder={placeholder}
      {...form?.getInputProps(validateName)}
    />
  );
};

export default withTranslation()(PasswordField);
